import { useEffect } from "react";

const SITE = "https://nicolesrl.it";

export function useSEO({ title, description, path = "/", lang = "it" }) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path, lang]);
}
